module.exports = __webpack_public_path__ + "static/media/pipa-partitura.426b63f3.png";